import React, { Component, createRef, Fragment } from "react";
import ReactGA from "react-ga4";
import { connect } from "react-redux";
import { fromJS } from "immutable";
import { bindActionCreators } from "redux";
import { ActionCreator } from "actions";
import * as queryString from "query-string";
import "containers/SearchQuick/styles.scss";
import { ProviderTypeListItem, NoImageTypeListItem } from "component/listItem";
import { ReactComponent as PuzzlePieceIcon } from "assets/icons/puzzle_piece.svg";
import { ReactComponent as PantoneIcon } from "assets/icons/pantone.svg";
import { ReactComponent as GearsIcon } from "assets/icons/gears.svg";
import { CategoryFiltersComponent } from "component/filters";
import ShowMoreFilters from "containers/ShowMoreFilters";
import { CategoryGames } from "component/list";
import { CommonTabs } from "component/common";

class SearchQuick extends Component {
  constructor(props) {
    super(props);
    this.searchTopRef = createRef();
    this.filterSentinelRef = createRef();
    this.setSearchQuick = this._setSearchQuick.bind(this);
    this.onShowMoreHandler = this._onShowMoreHandler.bind(this);
    this.fetchFilters = this._fetchFilters.bind(this);
    this.onFilterClickHandler = this._onFilterClickHandler.bind(this);
    this.onFilterClearHandler = this._onFilterClearHandler.bind(this);
    this.onApplyFilterClickHandler = this._onApplyFilterClickHandler.bind(this);
    this.getIcon = this._getIcon.bind(this);
    this.state = {
      searchQuickLinks: null,
      searchQuick: null,
      searchQuickIndex: 0,
      skeleton: [1, 2, 3, 4, 5, 6],
      activeFilter: null,
      isMinimized: false,
      isFilterStuck: false,
    };
  }

  componentDidMount() {
    this.initObserver();
    this.initFilterObserver();
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.show && this.props.show) {
      this.initObserver();
      this.initFilterObserver();
    } else if (prevProps.show && !this.props.show) {
      this.disconnectObserver();
      this.disconnectFilterObserver();
    }

    if (prevProps.searchQuick !== this.props.searchQuick) {
      this.setState({ isMinimized: false });
    }
  }

  componentWillUnmount() {
    this.disconnectObserver();
    this.disconnectFilterObserver();
  }

  disconnectObserver() {
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
  }

  disconnectFilterObserver() {
    if (this.filterObserver) {
      this.filterObserver.disconnect();
      this.filterObserver = null;
    }
  }

  initObserver() {
    this.disconnectObserver();

    if (!this.searchTopRef.current) {
      setTimeout(() => this.initObserver(), 100);
      return;
    }

    const options = {
      root: null,
      rootMargin: "0px",
      threshold: 0.1,
    };

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        this.setState({ isMinimized: !entry.isIntersecting });
      });
    }, options);

    this.observer.observe(this.searchTopRef.current);
  }

  initFilterObserver() {
    this.disconnectFilterObserver();

    if (!this.filterSentinelRef.current) {
      setTimeout(() => this.initFilterObserver(), 100);
      return;
    }

    this.filterObserver = new IntersectionObserver(
      ([entry]) => {
        this.setState({ isFilterStuck: !entry.isIntersecting });
      },
      { threshold: 0, rootMargin: "-50px 0px 0px 0px" },
    );

    this.filterObserver.observe(this.filterSentinelRef.current);
  }

  _getIcon(rel) {
    switch (rel) {
      case "search-quick-types.themes":
      case "searchQuickTypes.themes":
        return PantoneIcon;
      case "search-quick-types.providers":
      case "searchQuickTypes.providers":
        return GearsIcon;
      case "search-quick-types.special-features":
      case "searchQuickTypes.specialFeatures":
        return PuzzlePieceIcon;
      default:
        return null;
    }
  }

  _fetchFilters(route, filters) {
    let params = new URLSearchParams();
    if (filters) {
      filters.forEach((filter) => {
        filter.get("values").forEach((value) => {
          if (value.get("toggled") === true) {
            params.append(filter.get("id"), value.get("id"));
          }
        });
      });
    }
  }

  _onFilterClickHandler(subCategory, value) {
    this.props.setActiveFilter(this.props.filtersLink, subCategory, value);
  }

  _onFilterClearHandler(subCategory) {
    this.props.clearFilterByCategory(
      this.props.filtersLink.get("rel"),
      subCategory,
    );
  }

  _onApplyFilterClickHandler() {
    this.props.showFilters(!this.props.filtersVisible);
  }

  _onShowMoreHandler(rel, route) {
    let params = {
      showMore: rel,
      route: btoa(encodeURIComponent(JSON.stringify(route.toJSON()))),
    };
    let newLoc = `${this.props.location.pathname}?${queryString.stringify(
      params,
    )}`;
    this.props.navigateTo(newLoc);
  }

  _setSearchQuick(value) {
    let search = queryString.parse(this.props.location.search);
    search.searchQuick = value;
    let newLoc = `${this.props.location.pathname}?${queryString.stringify(
      search,
    )}`;
    this.props.navigateTo(newLoc);
  }

  _onReachEndX() {
    let searchQuick = this.state.searchQuick;
    let currentSearchQuick = searchQuick.get(this.props.searchQuick);

    let { totalPages, page, items, isLoading } = currentSearchQuick.toJSON();

    if (page < totalPages && !isLoading) {
      searchQuick = searchQuick.setIn(
        [this.props.searchQuick, "isLoading"],
        true,
      );
      this.setState({
        searchQuick,
      });

      let nextPage = page + 1;
      let params = {
        size: 20,
        page: nextPage,
      };

      this.props
        .fetchSearchQuick(this.props.quickLink, params)
        .then((resp) => {
          resp.items = items.concat(resp.items);
          searchQuick = searchQuick.mergeIn([this.props.searchQuick], resp);
          searchQuick = searchQuick.setIn(
            [this.props.searchQuick, "isLoading"],
            false,
          );
          this.setState({
            searchQuick,
          });
        })
        .catch((err) => {
          console.error(err);
        });
    }
  }

  setGAparameters() {
    let search = queryString.parse(this.props.location.search);
    if (search.searchQuick) {
      ReactGA.event({
        category: "Quick Search",
        action: `quicksearch.${search.searchQuick.split(".")[1]}`,
        label: search.searchQuick,
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    const currentPath =
      this.props.location.pathname + this.props.location.search;
    const nextPath = nextProps.location.pathname + nextProps.location.search;

    if (currentPath !== nextPath && nextProps.show) {
      this.setState({ isMinimized: false, isFilterStuck: false });
      setTimeout(() => {
        this.initObserver();
        this.initFilterObserver();
      }, 100);
    }

    if (this.props.q !== nextProps.q && nextProps.q === "") {
      if (this.props.searchQuick === undefined && this.state.searchQuickLinks) {
        let search = queryString.parse(nextProps.location.search);
        search.searchQuick = this.state.searchQuickLinks.getIn([
          this.state.searchQuickIndex,
          "rel",
        ]);
        let newLoc = `${this.props.location.pathname}?${queryString.stringify(
          search,
        )}`;
        this.props.navigateTo(newLoc);
      }
    }

    if (
      this.props.searchQuick !== nextProps.searchQuick &&
      nextProps.searchQuick
    ) {
      let searchQuickIndex = this.state.searchQuickLinks.findIndex((link) => {
        return link.get("rel") === nextProps.searchQuick;
      });
      this.setState({
        searchQuickIndex,
        isMinimized: false,
      });
    }

    if (
      this.props.searchQuickLinks !== nextProps.searchQuickLinks &&
      nextProps.searchQuickLinks
    ) {
      return this.props
        .fetchSearchQuickLinks(nextProps.searchQuickLinks)
        .then((resp) => {
          let searchQuickLinks = fromJS(resp);
          this.setState({
            searchQuickLinks,
          });
          this.props.setSearchQuickLinks(searchQuickLinks);
          return searchQuickLinks;
        })
        .catch((err) => {
          console.error(err);
        });
    }
  }

  render() {
    if (this.props.q !== "" || this.props.route === undefined) {
      return null;
    }
    let ListItem;
    if (
      this.props.route.get("rel") === "search-quick-types.providers" ||
      this.props.route.get("rel") === "searchQuickTypes.providers"
    ) {
      ListItem = ProviderTypeListItem;
    } else {
      ListItem = NoImageTypeListItem;
    }

    return (
      <Fragment>
        <div ref={this.searchTopRef} />
        <div className={`search-quick ${this.props.show ? "" : "d-none"}`}>
          <CommonTabs
            mode="rel"
            tabs={this.state.searchQuickLinks}
            selectedTab={this.props.searchQuick}
            isLoading={this.props.isLoading}
            onTabSelect={this.setSearchQuick}
            getIcon={this.getIcon}
            minimize={false}
          />
          <div ref={this.filterSentinelRef} className="filter-sentinel" />
          <div
            className={`category-filters-sticky ${
              this.state.isFilterStuck ? "is-stuck" : ""
            }`}
          >
            <CategoryFiltersComponent
              filters={this.props.filters}
              filterRoute={this.props.filtersLink}
              fetchFilters={(route) => {
                let params = new URLSearchParams();
                if (this.props.filters) {
                  this.props.filters.forEach((filter) => {
                    //if(filter.get('id') !== "providers") {
                    filter.get("values").forEach((value) => {
                      if (value.get("toggled") === true) {
                        params.append(filter.get("id"), value.get("id"));
                      }
                    });
                    //}
                  });
                }
                this.props.clearGames(this.props.route);
                this.props.fetchFilters(route, params);
              }}
              onApplyFilterClickHandler={(filter) => {
                this.onApplyFilterClickHandler();
                this.setState({
                  activeFilter: filter.get("id"),
                });
              }}
              onSortClick={() => {
                this.onApplyFilterClickHandler();
                this.setState({
                  activeFilter: "sortBy",
                });
              }}
              onFilterClickHandler={this.props.setActiveFilter}
              showSelectedFilter={false}
              games={this.props.games}
              link={this.props.route}
              sortBy={this.props.sortBy}
              sorts={this.props.sorts}
              enableClearAll={this.props.enableClearAll}
              clearAllFilters={this.props.clearAllFilters}
              isMobile={this.props.isMobile}
              sortingSize={this.props.sortingSize}
              filtersIsLoading={this.props.filtersIsLoading}
            />
          </div>
          <CategoryGames
            showAll={true}
            route={this.props.route}
            hasNoFilters={!this.props.filtersLink}
            refreshList={!this.props.filtersIsLoading}
            itemComponent={ListItem}
            isMobile={this.props.isMobile}
            isLoading={this.props.isLoading}
            isLoadingNext={this.props.isLoadingNext}
            hasNextPage={this.props.hasNextPage}
            games={this.props.games}
            sortBy={this.props.sortBy}
            currency={this.props.currency}
            fetchGames={() => {
              let params = new URLSearchParams();
              if (this.props.filters) {
                this.props.filters.forEach((filter) => {
                  filter.get("values").forEach((value) => {
                    if (value.get("toggled") === true) {
                      params.append(filter.get("id"), value.get("id"));
                    }
                  });
                });
              }
              if (this.props.sortBy) {
                params.append("sortBy", this.props.sortBy);
              }

              if (this.props.size) {
                params.append("size", this.props.size);
              }

              return this.props.fetchGames(this.props.route, params);
            }}
            onCategoryClickHandler={(item) => {
              let categoryLink = item.game.getIn(["links", 0]);
              this.onShowMoreHandler(categoryLink.get("rel"), categoryLink);
            }}
            imageFormat={this.props.imageFormat}
            latestBroadcast={this.props.latestBroadcast}
            onReachEnd={() => {
              let params = new URLSearchParams();
              params.append("page", this.props.page ? this.props.page + 1 : 1);

              if (this.props.filters) {
                this.props.filters.forEach((filter) => {
                  filter.get("values").forEach((value) => {
                    if (value.get("toggled") === true) {
                      params.append(filter.get("id"), value.get("id"));
                    }
                  });
                });
              }
              if (this.props.sortBy) {
                params.append("sortBy", this.props.sortBy);
              }

              if (this.props.size) {
                params.append("size", this.props.size);
              }

              return this.props.fetchGames(this.props.route, params);
            }}
          />
        </div>
        <ShowMoreFilters
          refreshOnRouteChange={false}
          filtersIsLoading={this.props.filtersIsLoading}
          activeFilter={this.state.activeFilter}
          filters={this.props.filters}
          filtersLink={this.props.filtersLink}
          sorts={this.props.sorts}
          games={this.props.games}
          onClose={() => {
            this.setState({
              activeFilter: null,
            });
          }}
        />
      </Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  let { q, searchQuick } = queryString.parse(ownProps.location.search);
  let isMobile = state.window.get("isMobile");
  let searchQuickLinks = state.links.get("searchQuickLinks");
  let quickLinks = state.search.get("quickLinks");
  let quickLink;
  let filtersLink;
  let filters;
  let filtersIsLoading;
  let sortBy;
  let sorts;
  let sortingSize = 0;
  let games;
  let isLoading;
  let isLoadingNext;
  let hasNextPage;
  let page;
  let tournamentPreview;
  let route;
  let enabledFilters;
  let enableClearAll;

  try {
    games = state.games.getIn([searchQuick, "data"]);
  } catch (err) {}
  try {
    isLoading = state.games.getIn([searchQuick, "isLoading"]);
  } catch (err) {}
  try {
    isLoadingNext = state.games.getIn([searchQuick, "isLoadingNext"]);
  } catch (err) {}
  try {
    hasNextPage = games.get("totalPages") > games.get("page");
  } catch (err) {}
  try {
    page = games.get("page");
  } catch (err) {}
  try {
    tournamentPreview = state.tournaments.getIn([searchQuick]);
  } catch (err) {}

  try {
    quickLink =
      searchQuick !== undefined
        ? quickLinks.find((link) => {
            return link.get("rel") === searchQuick;
          })
        : quickLinks.get(0);
  } catch (err) {}

  try {
    route = quickLinks.find((link) => {
      return link.get("rel").indexOf(searchQuick) > -1;
    });
  } catch (err) {}

  try {
    filtersLink = route.get("links").find((link) => {
      return link.get("rel").indexOf("filters") > -1;
    });
  } catch (err) {}
  try {
    enabledFilters = state.filters.getIn([
      filtersLink.get("rel"),
      "data",
      "filters",
    ]);
  } catch (err) {}
  try {
    sortBy = state.filters.getIn([filtersLink.get("rel"), "data", "sortBy"]);
  } catch (err) {}

  try {
    sorts = state.filters.getIn([filtersLink.get("rel"), "data", "sorts"]);
  } catch (err) {}

  try {
    filters = state.filters.getIn([filtersLink.get("rel"), "data", "filters"]);
  } catch (err) {}

  try {
    let toggledSize = 0;
    for (var i = 0; filters.size > i; i++) {
      toggledSize = filters.getIn([i, "toggledCount"]);
      sortingSize = sortingSize + toggledSize;
    }
  } catch (err) {}

  try {
    filtersIsLoading = state.filters.getIn([
      filtersLink.get("rel"),
      "isLoading",
    ]);
  } catch (err) {}

  try {
    enableClearAll = state.filters.getIn([
      filtersLink.get("rel"),
      "enableClearAll",
    ]);
  } catch (err) {}

  return {
    q,
    isMobile,
    searchQuick,
    searchQuickLinks,
    route,
    games,
    isLoading,
    isLoadingNext,
    hasNextPage,
    page,
    tournamentPreview,
    sortBy,
    sorts,
    sortingSize,
    filtersLink,
    filters,
    filtersIsLoading,
    enabledFilters,
    enableClearAll,
    quickLink,
    imageFormat: state.window.get("imageFormat"),
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return bindActionCreators(ActionCreator, dispatch);
};

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  return Object.assign({}, stateProps, ownProps, {
    navigateTo: (path) => ownProps.history.push(path),
    fetchGames: (route, params) => dispatchProps.fetchGames(route, params),
    clearGames: (route) => dispatchProps.clearGames(route),
    fetchFilters: (route, params) => dispatchProps.fetchFilters(route, params),
    fetchSearchQuickLinks: (route) =>
      dispatchProps.fetchSearchQuickLinks(route),
    setSearchQuickLinks: (data) => dispatchProps.setSearchQuickLinks(data),
    showFilters: (bol) => dispatchProps.showFilters(bol),
    fetchSearchQuick: (route, params) =>
      dispatchProps.fetchSearchQuick(route, params),
    setSearchQuick: (data) => dispatchProps.setSearchQuick(data),
    setActiveFilter: (category, subCategory, filter) =>
      dispatchProps.setActiveFilter(category, subCategory, filter),
    clearAllFilters: (category) => dispatchProps.clearAllFilters(category),
  });
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps,
)(SearchQuick);
